import React,{Component} from 'react';
import {bindActionCreators} from "redux";
import {RootActions} from "../../../shared/root-action";
import {connect} from "react-redux";
import TicketLists from '../../presentational/ticket-list';

require('dotenv').config();

class Tickets extends Component {
    render() {
        return (
            <div className="col-12" style={{padding:'15px 10px'}}>
                <h4 className="text-title">Tickets</h4>
                <TicketLists />
            </div>
        )
    }
}

const mapStateToProps = (state) => {

    return {

        permission_state: state.permission_state,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(Tickets);